module.exports = __webpack_public_path__ + "static/icon_item1.b7d0ab66.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item1.png
// module id = 1041
// module chunks = 2